import { render, staticRenderFns } from "./Sport.vue?vue&type=template&id=3e55730c&scoped=true"
import script from "./Sport.vue?vue&type=script&lang=js"
export * from "./Sport.vue?vue&type=script&lang=js"
import style0 from "./Sport.vue?vue&type=style&index=0&id=3e55730c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e55730c",
  null
  
)

export default component.exports